  <template>
  <div>
  <Transition name="fade-slide" appear>
    <router-view />
  </Transition>
  </div>
</template>
